import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-agent-search-phone-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAgentSearchPhoneIconProps extends SvgIconProps {}

export function CcfAgentSearchPhoneIcon(props: CcfAgentSearchPhoneIconProps) {
  return (
    <SvgIcon
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 25 25"
        sx={{fontSize: '24px'}}
      >
        <path
          d="M16.3753 14.8604C16.3753 14.8604 15.671 15.9622 15.6086 16.0556C15.5462 16.1489 15.4071 16.4257 14.751 16.239C13.2379 15.6699 11.9002 14.7357 10.865 13.5252C9.64121 12.4677 8.70848 11.132 8.15088 9.63834C7.96358 8.98188 8.24069 8.84614 8.33379 8.78039C8.42689 8.71463 9.52874 8.01046 9.52874 8.01046C10.2702 7.57565 9.43126 5.71657 8.07968 4.82149C7.08188 4.15973 6.64377 4.22548 6.22428 4.55106C5.54107 5.0982 4.93005 5.72473 4.40502 6.4165C4.13918 6.78763 4.02556 7.2413 4.0863 7.68912C4.30543 9.10431 4.81089 10.4638 5.57369 11.6894C6.43349 13.1457 7.48702 14.4863 8.70728 15.677C9.88651 16.8883 11.2268 17.9425 12.693 18.8118C13.9067 19.5701 15.2699 20.0757 16.6962 20.2965C17.1471 20.3562 17.6042 20.242 17.9689 19.9784C18.6645 19.4478 19.2899 18.8362 19.8309 18.1575C20.1595 17.7333 20.2197 17.3006 19.5593 16.3016C18.6688 14.9569 16.8101 14.1191 16.3753 14.8604Z"
          fill="#5C2B83"
        ></path>
    </SvgIcon>
  );
}

export default CcfAgentSearchPhoneIcon;
